/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiPeriodicInterval } from './InternalApiPeriodicInterval';
import {
    InternalApiPeriodicIntervalFromJSON,
    InternalApiPeriodicIntervalFromJSONTyped,
    InternalApiPeriodicIntervalToJSON,
    InternalApiPeriodicIntervalToJSONTyped,
} from './InternalApiPeriodicInterval';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';

/**
 * 
 * @export
 * @interface InternalApiStartScenarioVersionTest
 */
export interface InternalApiStartScenarioVersionTest {
    /**
     * 
     * @type {Date}
     * @memberof InternalApiStartScenarioVersionTest
     */
    testDataTimeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiStartScenarioVersionTest
     */
    testDataTimeTo: Date;
    /**
     * 
     * @type {InternalApiPeriodicInterval}
     * @memberof InternalApiStartScenarioVersionTest
     */
    periodicInterval?: InternalApiPeriodicInterval;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalApiStartScenarioVersionTest
     */
    alertingIntervals: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiStartScenarioVersionTest
     */
    onAlertedEntitiesOnly: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiStartScenarioVersionTest
     */
    testSegments: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiStartScenarioVersionTest
     */
    testExcludedSegments: Array<string>;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiStartScenarioVersionTest
     */
    testParameters: Array<InternalApiScenarioVersionParameter>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiStartScenarioVersionTest
     */
    note?: string;
}

/**
 * Check if a given object implements the InternalApiStartScenarioVersionTest interface.
 */
export function instanceOfInternalApiStartScenarioVersionTest(value: object): value is InternalApiStartScenarioVersionTest {
    if (!('testDataTimeFrom' in value) || value['testDataTimeFrom'] === undefined) return false;
    if (!('testDataTimeTo' in value) || value['testDataTimeTo'] === undefined) return false;
    if (!('alertingIntervals' in value) || value['alertingIntervals'] === undefined) return false;
    if (!('onAlertedEntitiesOnly' in value) || value['onAlertedEntitiesOnly'] === undefined) return false;
    if (!('testSegments' in value) || value['testSegments'] === undefined) return false;
    if (!('testExcludedSegments' in value) || value['testExcludedSegments'] === undefined) return false;
    if (!('testParameters' in value) || value['testParameters'] === undefined) return false;
    return true;
}

export function InternalApiStartScenarioVersionTestFromJSON(json: any): InternalApiStartScenarioVersionTest {
    return InternalApiStartScenarioVersionTestFromJSONTyped(json, false);
}

export function InternalApiStartScenarioVersionTestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiStartScenarioVersionTest {
    if (json == null) {
        return json;
    }
    return {
        
        'testDataTimeFrom': (new Date(json['testDataTimeFrom'])),
        'testDataTimeTo': (new Date(json['testDataTimeTo'])),
        'periodicInterval': json['periodicInterval'] == null ? undefined : InternalApiPeriodicIntervalFromJSON(json['periodicInterval']),
        'alertingIntervals': json['alertingIntervals'],
        'onAlertedEntitiesOnly': json['onAlertedEntitiesOnly'],
        'testSegments': json['testSegments'],
        'testExcludedSegments': json['testExcludedSegments'],
        'testParameters': ((json['testParameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function InternalApiStartScenarioVersionTestToJSON(json: any): InternalApiStartScenarioVersionTest {
    return InternalApiStartScenarioVersionTestToJSONTyped(json, false);
}

export function InternalApiStartScenarioVersionTestToJSONTyped(value?: InternalApiStartScenarioVersionTest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'testDataTimeFrom': value['testDataTimeFrom'].toISOString(),
        'testDataTimeTo': value['testDataTimeTo'].toISOString(),
        'periodicInterval': InternalApiPeriodicIntervalToJSON(value['periodicInterval']),
        'alertingIntervals': value['alertingIntervals'],
        'onAlertedEntitiesOnly': value['onAlertedEntitiesOnly'],
        'testSegments': value['testSegments'],
        'testExcludedSegments': value['testExcludedSegments'],
        'testParameters': ((value['testParameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
        'note': value['note'],
    };
}

